export const FETCH_LIST = 'FETCH_LIST';
export const CREATE = 'CREATE';
export const COMPANY_INFO = 'COMPANY_INFO';
export const ALL_COMPANIES_LIST = 'ALL_COMPANIES_LIST';
export const COMPANY_WALL_POSTS = 'COMPANY_WALL_POSTS';
